import { SapMasterProductsDetail } from "../../features"

const SapMasterProductsDetailPage = () => {
  return <SapMasterProductsDetail />
}

export default SapMasterProductsDetailPage
